// Query keys
export const SEARCH_QUERY_KEY = 'search';
export const GRACE_AND_LAPSE_QUERY_KEY = 'graceAndLapse';

// Search query
export const SEARCH_ERROR = 'Failed to run search query';

// Search button
export const SEARCH__BUTTON_TEXT = 'Search...';
export const SEARCH__BUTTON_OPEN_SEARCH_KEYBOARD_SHORTCUT = '/';

// Search input
export const SEARCH___INPUT_PLACEHOLDER = 'Search...';
export const SEARCH___INPUT_CLOSE = 'Close';
export const SEARCH___INPUT_CLOSE_KEYBOARD_SHORTCUT = 'esc';

// Search results
export const SEARCH___RESULTS_NO_RESULTS = 'No results found';
export const SEARCH__RESULTS_ENTITY_TYPES = {
	POLICYHOLDER: 'entity.policyholder',
	POLICY: 'entity.policy2',
	CLAIM: 'entity.claim3',
	QUOTE: 'entity.new.business.policy.quote',
};
export const QUOTE_OPTION_TITLE = 'Quote';
export const QUOTE_OPTION_SUBTITLE = 'Name:';
export const CLAIM_OPTION_TITLE = 'Claim';
export const POLICY_OPTION_TITLE = 'Policy';
export const SEARCH_DOCS_URL =
	'https://docs.socotra.com/production/data/search.html';
